import { IDriveViewLinkableFile } from '@commenda/types/src/drive-view/types';
import { SWRFetcher } from '@commenda/utils';
import { LegacyDocumentType } from '@prisma/client';
import useSWR from 'swr';

export interface ILinkableEntityFilesResponse {
  items: IDriveViewLinkableFile[];
  hasMore: boolean;
}

export function useLinkableEntityFiles({
  corporationId,
  excludeDocumentType,
  search,
  enabled = true,
}: {
  corporationId: number;
  excludeDocumentType?: LegacyDocumentType;
  search?: string;
  enabled?: boolean;
}) {
  const query = new URLSearchParams();
  if (excludeDocumentType)
    query.append('excludeDocumentType', excludeDocumentType);
  if (search?.trim()) query.append('search', search.trim());

  const queryString = query.toString();
  const url = enabled
    ? `drive-view/entity/${corporationId}/linkable-files${queryString ? `?${queryString}` : ''}`
    : null;

  const { data, error, isLoading, mutate } =
    useSWR<ILinkableEntityFilesResponse>(url, SWRFetcher({ method: 'GET' }), {
      keepPreviousData: true,
    });

  return { data, error, isLoading, mutate };
}
